import { render, staticRenderFns } from "./LabPackages.vue?vue&type=template&id=5d7748d6&"
import script from "./LabPackages.vue?vue&type=script&lang=js&"
export * from "./LabPackages.vue?vue&type=script&lang=js&"
import style0 from "./LabPackages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports